<form [formGroup]="frm">
  <div class="row">
    <div class="col-6">
      <mat-form-field>
        <input type="text" matInput formControlName="name" placeholder="File Name" (keyup)="notifyChanged($event)" autocomplete="off" />
        <mat-hint>The name for your exported file</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-6" formGroupName="configuration">
      <mat-form-field>
        <input matInput [matDatepicker]="expiresBefore" formControlName="expiresBefore" (dateChange)="notifyChanged()" placeholder="Expires Before" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="expiresBefore"></mat-datepicker-toggle>
        <mat-datepicker #expiresBefore disabled="false"></mat-datepicker>
      </mat-form-field>
      <mat-slide-toggle color="primary" formControlName="expired" (change)="notifyChanged()"> Export Expired Vouchers Only</mat-slide-toggle>
    </div>
  </div>
  <div formGroupName="configuration">
    <div class="row">
      <div class="col-12">
        <h4>Select Assets to export</h4>

        <table mat-table [dataSource]="ds" formArrayName="assets" class="table table-striped table-condensed table-bordered">
          <ng-container matColumnDef="vendor">
            <th mat-header-cell *matHeaderCellDef> Vendor </th>
            <td mat-cell *matCellDef="let item; let index = index" [formGroupName]="index" class="p-2">
              <mat-form-field>
                <input type="text" matInput formControlName="vendor" placeholder="" />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Voucher Value </th>
            <td mat-cell *matCellDef="let item; let index = index" [formGroupName]="index" class="p-2">
              <mat-form-field>
                <input type="number" matInput formControlName="value" placeholder="" />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="numberOfVouchers">
            <th mat-header-cell *matHeaderCellDef> # of Vouchers </th>
            <td mat-cell *matCellDef="let item; let index = index" [formGroupName]="index" class="p-2">
              <mat-form-field>
                <input type="number" matInput formControlName="numberOfVouchers" placeholder="" (keyup)="notifyChanged($event)" (change)="notifyChanged($event)" />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let item; let index = index" [formGroupName]="index" class="p-2">
              <button type="button" class="btn btn-danger" (click)="remove(index, $event)"><em class="fas fa-trash"></em> Remove</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="headers"></tr>
          <tr mat-row *matRowDef="let row; columns: headers;"></tr>
        </table>
        <div *ngIf="assets.length === 0" class="text-muted text-center">
          <p>The are no assets available for export or all items have been cleared.</p>
        </div>
      </div>
    </div>
  </div>
</form>
